export enum OfflinePhases {
  EOI = "EOI",
  CONTRACT_EXECUTED = "Contract Executed",
  UNCONDITIONAL = "Unconditional",
}
